import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';

// KDS draws a small square Badge at 20px.
export const BADGE_SIZE = 'small';
const BADGE_WIDTH = 20;
const BADGE_GAP = 6;

// The KDS SelectMenu root holds the label <span> and the trigger <button>.
// display: contents lifts both into this row; moving the button last puts the
// badge between them, and the button reaches back under the badge so a click
// on the badge opens the menu and the focus ring takes the badge in.
export const Wrapper = styled.div`
  display: flex;
  align-items: center;

  & > div {
    display: contents;
  }

  ${({ decorated }) =>
    decorated &&
    css`
      & > div > button {
        order: 1;
        margin-left: ${rem(-BADGE_WIDTH)};
        padding-left: ${rem(BADGE_WIDTH + BADGE_GAP)};
      }
    `}
`;

export const BadgeSlot = styled.span`
  display: flex;
  position: relative;
  z-index: 1;
  pointer-events: none;
`;
